import decode from "jwt-decode";

export const setStoredUser = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const getStoredUser = (verifyExp = false) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (!verifyExp) {
    return user;
  }

  if (user) {
    const expirationTime = decode(user.access).exp * 1000;
    const currentTime = new Date().getTime();
    if (currentTime < expirationTime) {
      return user;
    }
  }
};

export const deleteStoredUser = () => {
  localStorage.removeItem("user");
};

export const getErrorAsList = (error) => {
  if (error.response.data?.constructor === Object) {
    const firstValue = Object.values(error.response.data)[0];
    if (Array.isArray(firstValue)) {
      return firstValue;
    }

    return [firstValue];
  }

  if (error.response.status) {
    return [`Ocorreu um erro! (${error.response.status}).`];
  }

  return [`Ocorreu um erro! (${error.message}).`];
};
